import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.span`
	font-family: ${helpers.font.family.header};
	padding: 0 16px;
	font-size: 18px;
	font-weight: 500;
	margin-bottom: 6px;
	display: block;
`
